import { useState } from 'react'
import { Row, Col, Tabs } from 'antd'

// components
import CommentsSection from '../../taskRefactored/comments.section'
import ActivitySection from '../../taskRefactored/activity.section'

// styles
import styles from './ProjectCommentsTabs.module.css'

const ProjectCommentsTabs = ({
    taskId,
    taskListKind = 'support',
    setFilteredMembers,
    mentionData,
    files,
    setCommentChange,
    commentChange,
    onTaskUpdate,
}) => {
    const [activeTab, setActiveTab] = useState('comments')

    const tabs = [
        {
            key: 'comments',
            label: 'Comments',
            children: (
                <CommentsSection
                    taskId={taskId}
                    taskListKind={taskListKind}
                    setFilteredMembers={setFilteredMembers}
                    mentionData={mentionData}
                    files={files}
                    setCommentChange={setCommentChange}
                    commentChange={commentChange}
                    onTaskUpdate={onTaskUpdate}
                />
            ),
        },
        {
            key: 'activity',
            label: 'All activity',
            children: (
                <ActivitySection
                    taskId={taskId}
                    isActive={activeTab === 'activity'}
                    taskListKind={taskListKind}
                />
            ),
        },
    ]

    return (
        <div className={styles.tabsContainer}>
            <Row
                style={{
                    width: '100%',
                    padding: '0px 10px 0px 25px',
                }}
                justify="space-between"
                align="middle"
            >
                <Col span={24}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={(key) => setActiveTab(key)}
                        items={tabs}
                        className={styles.customTabs}
                        tabBarStyle={{
                            marginBottom: 0,
                        }}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default ProjectCommentsTabs
